export default "__VITE_ASSET__DoykHUTw__"